import { ActivitiesInput } from '@modules/board/BoardTableRowDialog/ViewRowActivities/ActivitiesMessageInput';
import { ConversationMessageInput } from '@modules/conversation-message/ConversationMessageInput';
import { useConversationEditor } from '@modules/conversation/hooks/useConversationEditor';
import { useConversationContext } from 'src/provider/ConversationContext';
import { useGatheringChatContext } from '../useGatheringChatContext';

export const GatheringChatInput = ({
  isGuest,
  disabled,
}: { isGuest?: boolean; disabled?: boolean }) => {
  const { handleTextMessage, handleFileSelect, editorConfig, sessionRef } =
    useGatheringChatContext();

  const { showInput } = useConversationContext();

  const { editor, editorLoaded } = useConversationEditor({
    conversationId: sessionRef,
    editorConfig,
  });

  if (!editorLoaded || !showInput) return null;

  return (
    <ActivitiesInput>
      <ConversationMessageInput
        handleTextMessage={handleTextMessage}
        handleFileSelect={handleFileSelect}
        editor={editor}
        disabled={disabled}
        iconSize={20}
        allowOptions={!isGuest}
        allowAskAi={!isGuest}
        allowSoundBoard={false}
        showMediaInputActions={true}
      />
    </ActivitiesInput>
  );
};
